<script>
export default {
  name: "DomainError"
}
</script>

<template>
  <v-app class="bg-soft" style="background: #f8f8fb">
    <img class="img-fluid" src="@/assets/images/login_background.jpg" style="position: absolute;z-index: -999;min-height: 100%;max-height: 100%;width: 100%;" />
    <div class="d-flex h-100 justify-content-center align-items-center mx-3" style="opacity: .8" >
      <div class="card shadow-lg overflow-hidden login-container" style="border-radius: 20px; width: 448px; height: 565px">
        <div class="bg-soft">
          <div class="row p-5 mx-5">
            <img class="img-fluid pb-5" src="@/assets/images/error-img.png"/>
            <div class="account-pages my-5">
              <div class="display-2 fw-medium">
            <h1 class="display-4 fw-medium text-center">
              4<i class="bx bx-buoy bx-spin text-primary display-4"></i>4
            </h1>
              </div>
            </div>
          </div>
          <div class="row text-center">
            <h3>Girdiğiniz adrese kayıtlı bir alan adı bulunmamaktadır !</h3>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<style scoped>

</style>